import { Search, Download } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Button } from "@/components/ui/button";

function exportToCSV(data, filename) {
  if (!data || data.length === 0) return;
  const headers = Object.keys(data[0]);
  const rows = data.map((row) =>
    headers.map((h) => {
      const val = row[h];
      if (val === null || val === undefined) return "";
      const str = String(val);
      return str.includes(",") || str.includes('"') || str.includes("\n")
        ? `"${str.replace(/"/g, '""')}"` : str;
    }).join(",")
  );
  const csv = [headers.join(","), ...rows].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename || "export.csv";
  document.body.appendChild(a); a.click();
  document.body.removeChild(a); URL.revokeObjectURL(url);
}

/**
 * Search + filter bar that sits above a data table.
 * filters: [{ key, placeholder, options: [{value, label}] }]
 * csvData: array of plain objects to export; csvFilename: download filename
 */
export function TableToolbar({ search, onSearch, filters = [], csvData, csvFilename, testId = "table-toolbar" }) {
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={testId}>
      <div className="relative min-w-[200px] max-w-sm flex-1">
        <Search className="pointer-events-none absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          data-testid="toolbar-search-input"
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          placeholder="Search…"
          className="pl-9 h-9 text-sm bg-background"
        />
      </div>
      {filters.map((f) => (
        <Select key={f.key} value={f.value || "ALL"} onValueChange={(v) => f.onChange(v === "ALL" ? "" : v)}>
          <SelectTrigger data-testid={`toolbar-filter-${f.key}`} className="h-9 w-auto min-w-[150px] text-sm">
            <SelectValue placeholder={f.placeholder} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="ALL">{f.placeholder}</SelectItem>
            {(f.options || []).map((o) => (
              <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      ))}
      {csvData && csvData.length > 0 && (
        <Button
          variant="outline"
          size="sm"
          className="h-9 text-sm shrink-0"
          onClick={() => exportToCSV(csvData, csvFilename || "export.csv")}
          data-testid="toolbar-export-button"
        >
          <Download className="h-3.5 w-3.5 mr-1.5" />
          Export
        </Button>
      )}
    </div>
  );
}
